import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { SttFullDialog } from '../../../sporttia/dialogs/SttFullDialog';
import { SttFormAttendance } from '../../../sporttia/forms/SttFormAttendance';
import type { Activity } from '../../../types/models/Activity';

type AttendancesDialogProps = {
    activity: Activity;
    open: boolean;
    onClose: () => void;
};

export default function AttendancesDialog({
    activity,
    open,
    onClose,
}: AttendancesDialogProps) {
    const { t } = useTranslation();

    return (
        <SttFullDialog
            title={t('generic.assistences')}
            open={open}
            onClose={onClose}
            urlPath={`/activities/${activity.id}/attendances`}
        >
            <Box className="p-4">
                <SttFormAttendance activity={activity} />
            </Box>
        </SttFullDialog>
    );
}
